import { Language } from '../interfaces/language.interface';

export const SharedHeaders = {
  ContentType: 'ContentType'
};

export const SharedUrls = {
  Site: '/',
  Login: '/login',
  ChangeAccount: '/manage-accounts',
  ChangeLanguage: '/change-language',
  Contracts: '/contracts',
  User: '/user',
  Region: '/user/region',
};

export const SharedApiUrls = {
  ServiceRequest: '/api/servicerequest',
  FileUpload: '/upload',
  Permit: '/api/permit'
};

export const ContentTypes = {
  xwwwformurlencoded: 'application/x-www-form-urlencoded'
};

export const Languages: Language[] = [
  { name: 'عربى', code: 'ar', isDefault: false, dir: 'rtl', locale: 'ar' },
  { name: 'English', code: 'en', isDefault: true, dir: 'ltr', locale: 'en-US' }

];
